import { render, staticRenderFns } from "./alertPhone.vue?vue&type=template&id=5b05e63f&scoped=true"
import script from "./alertPhone.vue?vue&type=script&lang=js"
export * from "./alertPhone.vue?vue&type=script&lang=js"
import style0 from "./alertPhone.vue?vue&type=style&index=0&id=5b05e63f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b05e63f",
  null
  
)

export default component.exports